import Cash from "./Cash/index.jsx";
import Tournament from "./Tournament/index.jsx";
import History from "./History/index.jsx";

const CombinedLobbyPages = {
    Cash,
    Tournament,
    History,
}

export default CombinedLobbyPages